module.exports = __webpack_public_path__ + "static/media/GangsIcon.be4ad498.png";